import UserActionError from '@/interfaces/errors/userAction'; // const PREFIX = 'Editor: share: ChartShare: errors:';

export const createImageDownloadError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix} generate download image: ${err}`);
  actionErr.userMessage = 'There was an issue generating your image, please try again or contact us for help.';
  return actionErr;
};
export const createVideoDownloadError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix} generate download video: ${err}`);
  actionErr.userMessage = 'There was an issue generating your video, please try again or contact us for help.';
  return actionErr;
};
export const createImagePreviewError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix} generate image preview: ${err}`);
  actionErr.userMessage = 'There was an issue generating your image, please try again or contact us for help.';
  return actionErr;
};